"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/web.dom.iterable");
var _GiftCardUploadPane = _interopRequireDefault(require("./GiftCardUploadPane"));
var _coupon_combo = require("@/api/member/coupon_combo.js");
var _gift_card = require("@/api/community/gift_card.js");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'GiftCardConfigPane',
  components: {
    GiftCardUploadPane: _GiftCardUploadPane.default
  },
  props: {
    fnId: {
      type: String,
      default: ''
    },
    imgAccessDomain: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      refreshKey: 0,
      loading: false,
      formData: {
        title: '',
        subtitle: '',
        type: 'member',
        // 类型
        activateStatus: 'active',
        description: '',
        // 描述
        coverImage1: '',
        // 封面图片1
        coverImage2: '',
        // 封面图片2
        coverImage3: '',
        // 封面图片3
        coverImage4: '',
        // 封面图片4
        faceValues: []
      },
      couponLoading: false,
      couponList: [],
      extraCouponLoading: false,
      extraCouponList: [],
      selectCouponDialog: {
        dialogVisible: false,
        couponLoading: false,
        type: '',
        title: '',
        currRow: null,
        checkedCoupon: {},
        couponList: []
      }
    };
  },
  created: function created() {
    if (this.fnId) {
      // 加载数据
      this.loadGiftCard();
    }
  },
  methods: {
    loadGiftCard: function loadGiftCard() {
      var _this = this;
      this.loading = true;
      (0, _gift_card.getGiftCard)(this.fnId).then(function (response) {
        var data = response.data;
        if (data) {
          _this.formData.title = data.giftCard.title;
          _this.formData.subtitle = data.giftCard.subTitle;
          _this.formData.type = data.giftCard.type;
          _this.formData.activateStatus = data.giftCard.activateStatus;
          _this.formData.description = data.giftCard.description;
          _this.formData.coverImage1 = data.giftCard.coverImage1;
          _this.formData.coverImage2 = data.giftCard.coverImage2;
          _this.formData.coverImage3 = data.giftCard.coverImage3;
          _this.formData.coverImage4 = data.giftCard.coverImage4;
          if (data.faceValues && data.faceValues.length > 0) {
            data.faceValues.forEach(function (faceValue) {
              faceValue.coupons = faceValue.coupons || [];
              faceValue.extraCoupons = faceValue.extraCoupons || [];
              _this.formData.faceValues.push(faceValue);
            });
          }
        }
        _this.refreshKey += 1;
        _this.loading = false;
      }, function () {
        _this.loading = false;
      });
    },
    submitForm: function submitForm() {
      var _this2 = this;
      if (this.fnId) {
        // 更新
        var data = _objectSpread({
          fnId: this.fnId
        }, this.formData);
        (0, _gift_card.updateGiftCard)(data).then(function () {
          _this2.$message({
            message: '更新成功',
            type: 'success'
          });
          _this2.$emit('success');
        });
      } else {
        // 创建
        (0, _gift_card.createGiftCard)(this.formData).then(function () {
          _this2.$message({
            message: '创建成功',
            type: 'success'
          });
          _this2.$emit('success');
        });
      }
    },
    selectCoupon: function selectCoupon(row, type) {
      this.selectCouponDialog.dialogVisible = true;
      this.selectCouponDialog.currRow = row;
      this.selectCouponDialog.type = type;
      if (type === 'gift') {
        this.selectCouponDialog.title = '选择添加优惠券';
      } else {
        this.selectCouponDialog.title = '选择添加额外优惠券';
      }
      this.selectCouponDialog.checkedCoupon = {};
      this.selectCouponDialog.couponList = [];
    },
    handleAddFaceValue: function handleAddFaceValue() {
      this.formData.faceValues.push({
        faceValue: 0,
        tip: '',
        extraTip: '',
        coupons: [],
        extraCoupons: []
      });
    },
    handleDeleteFaceValue: function handleDeleteFaceValue(index) {
      this.formData.faceValues.splice(index, 1);
    },
    deleteCheckedCoupon: function deleteCheckedCoupon(row, coupon, type) {
      var coupons = [];
      if (type === 'gift') {
        coupons = row.coupons || [];
      } else if (type === 'extra_gift') {
        coupons = row.extraCoupons || [];
      }
      if (coupons.length > 0) {
        for (var i = 0; i < coupons.length; i++) {
          var item = coupons[i];
          if (item.couponFnId === coupon.couponFnId) {
            coupons.splice(i, 1);
            break;
          }
        }
      }
    },
    sureSelectCoupon: function sureSelectCoupon() {
      this.selectCouponDialog.dialogVisible = false;
      var coupons = [];
      if (this.selectCouponDialog.type === 'gift') {
        coupons = this.selectCouponDialog.currRow.coupons || [];
      } else if (this.selectCouponDialog.type === 'extra_gift') {
        coupons = this.selectCouponDialog.currRow.extraCoupons || [];
      }
      var exist = false;
      if (this.selectCouponDialog.checkedCoupon && this.selectCouponDialog.checkedCoupon.couponFnId) {
        for (var i = 0; i < coupons.length; i++) {
          var item = coupons[i];
          if (item.couponFnId === this.selectCouponDialog.checkedCoupon.couponFnId) {
            exist = true;
            break;
          }
        }
        if (!exist) {
          coupons.push(this.selectCouponDialog.checkedCoupon);
        }
      }
      this.selectCouponDialog.checkedCoupon = {};
    },
    fetchCoupons: function fetchCoupons(query) {
      var _this3 = this;
      this.selectCouponDialog.couponList = [];
      this.selectCouponDialog.couponLoading = true;
      if (query) {
        var params = {
          couponName: query
        };
        (0, _coupon_combo.queryCouponComboSearch)(params).then(function (response) {
          _this3.selectCouponDialog.couponList = response.data || [];
          _this3.selectCouponDialog.couponLoading = false;
        }, function () {
          _this3.selectCouponDialog.couponLoading = false;
        });
      } else {
        this.selectCouponDialog.couponLoading = false;
      }
    },
    fetchExtraCoupons: function fetchExtraCoupons(query) {
      var _this4 = this;
      if (query) {
        var params = {
          couponName: query
        };
        this.extraCouponLoading = true;
        this.extraCouponList = [];
        (0, _coupon_combo.queryCouponComboSearch)(params).then(function (response) {
          _this4.extraCouponList = response.data || [];
          _this4.extraCouponLoading = false;
        });
      } else {
        this.couponList = [];
      }
    },
    getImgUrl: function getImgUrl(index) {
      if (index === 1) {
        return this.formData.coverImage1;
      } else if (index === 2) {
        return this.formData.coverImage2;
      } else if (index === 3) {
        return this.formData.coverImage3;
      } else if (index === 4) {
        return this.formData.coverImage4;
      }
      return null;
    },
    handleUploadSuccess: function handleUploadSuccess(index, imageUrl) {
      if (index === 1) {
        this.formData.coverImage1 = imageUrl;
      } else if (index === 2) {
        this.formData.coverImage2 = imageUrl;
      } else if (index === 3) {
        this.formData.coverImage3 = imageUrl;
      } else if (index === 4) {
        this.formData.coverImage4 = imageUrl;
      }
    }
  }
};